// client/src/components/Layout.tsx
import React from 'react';
import { Box } from '@chakra-ui/react';
import BackgroundSlideshow from './BackgroundSlideshow';

interface LayoutProps {
  children: React.ReactNode;
  images: string[];
}

const Layout: React.FC<LayoutProps> = ({ children, images }) => {
  return (
    <Box position="relative" minH="100vh">
      <BackgroundSlideshow 
        images={images} 
        interval={8000} 
        overlayOpacity={0.4} 
      />
      <Box position="relative" zIndex={1}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;